// src/services/realtimeService.js
import { supabase } from './supabase';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const realtimeService = {
  subscribeToOrders: (restaurantId, callback, onStatusUpdate) => {
    console.log('Subscribing to orders for restaurant:', restaurantId);

    const channel = supabase
      .channel(`restaurant-${restaurantId}`)
      .on('broadcast', { event: 'new_order' }, (payload) => {
        console.log('New order broadcast received:', payload);
        callback({ id: payload.payload?.orderId, ...payload.payload });
      })
      .on('broadcast', { event: 'order_status_update' }, (payload) => {
        if (onStatusUpdate) onStatusUpdate(payload.payload);
      })
      .subscribe((status) => {
        console.log('Realtime subscription status:', status);
      });

    return channel;
  },

  subscribeToOrderUpdates: (restaurantId, callback) => {
    console.log('Subscribing to order updates for restaurant:', restaurantId);
    
    const channel = supabase
      .channel(`order-updates-${restaurantId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'orders',
          filter: `restaurant_id=eq.${restaurantId}`
        },
        (payload) => {
          console.log('Order updated:', payload);
          callback(payload.new);
        }
      )
      .subscribe();

    return channel;
  },

  // Send broadcast via Edge Function (uses service role key — same mechanism as new_order)
  broadcastOrderStatusUpdate: async (restaurantId, orderId) => {
    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/customer-api`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ action: 'broadcastStatusUpdate', restaurantId, orderId }),
      });
      console.log('[broadcast] order_status_update via Edge Function:', res.status);
    } catch (e) {
      console.warn('[broadcast] order_status_update failed:', e.message);
    }
  },

  unsubscribe: (channel) => {
    if (channel) {
      console.log('Unsubscribing from channel');
      supabase.removeChannel(channel);
    }
  }
};